Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDisabled = void 0;
var _reactNative = require("react-native-web");
var useDisabled = exports.useDisabled = function useDisabled() {
  var disabled = Object.assign({
    opacity: 0.5
  }, _reactNative.Platform.select({
    web: {
      cursor: 'default'
    }
  }));
  return {
    disabled: disabled
  };
};